// removed by extract-text-webpack-plugin
module.exports = {"copy":"IMv5w5_Uh2RcASF6KIGEQ","title":"_32tz9PW5vDhEeo0uD4xRpB","subtitle":"WxfAARpkFsM9XemYgGSe7","intro":"zac2v65AMswTOpZWIchK-","timecode":"_3gCA0XTsPPLmobBehmyf8r","instruction":"_3PuEWyQRCxHWgJhDhghoIZ","helper":"_1b3Tnflh5XagyVcIOEpaOM","label":"_1ft3GxWX9ReBYqOuTu9aRy","error":"_1yIy91O_c-QV9LenWWcXWq","inputError":"ZxvUwllZC88alt29HtmCq","white":"R5efzxumQtE8AegenEYvd","black":"_1whxSipkyDJKkO0Ou-WKW2","gray":"_3bPQVFw33kydvwBH4d72ib","green":"_3O15IyVh95oi3sduetHz7y","bold":"_2e5xOOebM2YNl4Dqpy0nD3"};


//////////////////
// WEBPACK FOOTER
// ./src/elements/copy/copy.scss
// module id = 409
// module chunks = 0